import React, { useEffect, useRef, useState } from 'react';

/**
 * YorstrulyTeklif: performans pazarlaması teklif destesi (Klaud Outlet destesiyle aynı iskelet).
 * Route: /r/yorstruly-teklif (ProtectedRoute allowEmails)
 * Kaynak /home/glowyadmin/deck-src/yorstruly-teklif (yt-deck.src.html + build_deck.py).
 *
 * 12 slaytlık statik sunum, sabit 16:9 dikdörtgen. API çağrısı yok, marka seçimi gerekmiyor.
 * Ok tuşlarıyla ilerler, tarayıcıdan yazdırınca her slayt ayrı sayfa olur.
 *
 * Deck iframe içinde çalışır: kendi CSS'i `:root`, `.card` gibi global seçiciler ve
 * `position:fixed` kuralları içeriyor, srcDoc izolasyonu uygulamanın geri kalanını korur.
 *
 * HTML modülü ~1,1MB (gömülü fontlar, logolar, çerçeveler ve iki tam kanvas fotoğraf). Statik import
 * ana bundle'ı şişirdiği için sadece bu sayfa açıldığında dinamik olarak yükleniyor.
 */
export default function YorstrulyTeklif() {
  const frameRef = useRef(null);
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./yorstrulyTeklifDeckHtml')
      .then((mod) => {
        if (alive) setHtml(mod.default);
      })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px">Sunum yüklenemedi.</p>');
      });
    return () => {
      alive = false;
    };
  }, []);

  // Ok tuşları iframe'e odak gelmeden çalışmaz; sayfa açılır açılmaz odağı içeri veriyoruz.
  useEffect(() => {
    const frame = frameRef.current;
    if (!frame) return undefined;
    const focusDeck = () => {
      try {
        frame.contentWindow?.focus();
      } catch (err) {
        /* farklı origin değil ama yine de sessiz geç */
      }
    };
    frame.addEventListener('load', focusDeck);
    return () => frame.removeEventListener('load', focusDeck);
  }, [html]);

  const fill = {
    position: 'fixed',
    inset: 0,
    width: '100vw',
    height: '100vh',
    border: 0,
  };

  if (!html) return <div style={{ ...fill, background: '#E7E7EC' }} />;

  return <iframe ref={frameRef} title="Yorstruly · glowy teklif" srcDoc={html} style={fill} />;
}
